import { useState } from 'react';
import { faqs } from '@/mocks/homepage';

export default function FAQ() {
  const [openId, setOpenId] = useState<string | null>('faq-1');

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            快速了解kaiyun体育平台
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-foreground-950 text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openId === faq.id ? 'bg-primary-500 rotate-45' : 'bg-secondary-200'
                }`}>
                  <i className={`text-sm ${
                    openId === faq.id ? 'ri-subtract-line text-background-50' : 'ri-add-line text-secondary-600'
                  }`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}